import React from "react"
import { isAndroid, isIOS } from "react-device-detect"
import { Box, Flex, Text, Stack } from "@chakra-ui/core"
import StoreButton from "./StoreButton"

interface StoreUrls {
  playStoreUrl?: string
  appStoreUrl?: string
  amazonStoreUrl?: string
}
interface Props {
  gameId: string
  showTitle?: boolean
  stores: StoreUrls
}

const StoreBar: React.FC<Props> = ({ showTitle = true, gameId, stores }) => {
  const { playStoreUrl, appStoreUrl, amazonStoreUrl } = stores
  return (
    <Flex backgroundColor="orange.50" direction="column" py={6} px={6}>
      {showTitle && (
        <Flex justifyContent="center" mb={6} px={3}>
          <Text
            textAlign="center"
            as="h2"
            color="gray.800"
            fontSize={["2xl", "2xl", "4xl", "4xl"]}
            fontWeight="bold"
          >
            INSTALL ON YOUR MOBILE DEVICE
          </Text>
        </Flex>
      )}
      <Stack
        direction={["column", "row", "row", "row"]}
        spacing={[3, 3, 5]}
        justifyContent="center"
        alignItems="center"
      >
        {playStoreUrl && !isIOS && (
          <StoreButton gameId={gameId} type="playstore" url={playStoreUrl} />
        )}
        {appStoreUrl && !isAndroid && (
          <StoreButton gameId={gameId} type="appstore" url={appStoreUrl} />
        )}
        {amazonStoreUrl && !isIOS && (
          <StoreButton
            gameId={gameId}
            type="amazonstore"
            url={amazonStoreUrl}
          />
        )}
      </Stack>
    </Flex>
  )
}

export default StoreBar
